/* eslint-disable no-useless-escape */

import Vuex from 'vuex'

import {
  checkAxiosData,
  checkIfMobile,
  getAxiosConfig,
  getAxiosErr
} from 'fe-common'

import { catchError, concatMap, filter, from, throwError, timer } from 'rxjs'
import {
  handleMessages,
  REQUEST_TIMEOUT,
  serverErrorHandler
} from '../../modules/client/utilities'

import sportModule from '../../store/sport'
import loadingModule from '../../store/loading'
import headerModule from '../../store/header'
import authModule from '../../store/auth'
import marqueeModule from '../../store/marquee'
import bannerModule from '../../store/banner'
import jackpotModule from '../../store/jackpot'
import promotionModule from '../../store/promotion'
import userModule from '../../store/user'
import userIndexModule from '../../store/user/index'
import userFinancialServiceModule from '../../store/user/financial-service'
import userAccountSettingModule from '../../store/user/account-setting'
import userPromotionReceiveModule from '../../store/user/promotion-receive'
import userRecordQueryModule from '../../store/user/record-query'
import userStationLetterModule from '../../store/user/station-letter'
import userInboxModule from '../../store/user/inbox'
import annoModule from '../../store/anno'
import gameModule from '../../store/game'
import lotteryTicketModule from '../../store/lottery-ticket'
import chessModule from '../../store/chess'
import cockfightingModule from '../../store/cockfighting'
import cmsModule from '../../store/cms'
import kycModule from '../../store/user/kyc'
import subscribeModule from '../../store/subscribe'
import websocketModule from '../../store/websocket'
import vipModule from '../../store/vip'
import popupModule from '../../store/popup'

const store = () =>
  new Vuex.Store({
    strict: false,
    state: () => ({
      isMobile: false,
      // todo: 以下在 Native APP 出來後需要刪除
      // todo: deprecated start
      isAPP: false,
      // todo: deprecated end,
      isDesktop: false,
      isIPhone: false,
      httpStatusCodes: {},
      // for free demo domain in KB
      locales: process.env.SWITCH_LOCALES.split(/,\s?/).filter(Boolean),
      locale: null,
      domain: null,
      userAgent: null, // kb issue - 1058: Mars 要求紀錄確認用,
      deviceId: null,
      isPageLoaded: false,

      // format:
      // {
      //   type: 'MAINTAIN', // custom to condition
      //   style: 'warning', // 'primary' | 'secondary' | 'success' | 'danger' | 'warning' | 'info' | 'light' | 'dark'
      //   message: '',
      //   data: { // ... }
      // }
      globalMessage: null,

      version: '0.0.0',

      platform: null // Platform.js - A platform detection library that works on nearly all JavaScript platforms.
    }),
    actions: {
      async nuxtServerInit(context, { req, res, error, $dayjs }) {
        const { commit, state, dispatch } = context

        commit(
          'LOCALE',
          req.cookies.locale || process.env.DEFAULT_LOCALE || 'zh'
        )

        //
        // 是否啟用長期維護
        //
        if (process.env?.ENABLE_MAINTENANCE === 'true') {
          return error({
            statusCode: 599
          })
        }

        //
        // 取得版本號碼
        //
        commit('VERSION', require('../../package.json').version)

        $dayjs.tz.setDefault(process.env.DEFAULT_ZONE)

        //
        // todo: 錯誤登入 (特定用戶資料) - 以原官方的 server 傳值給 client 作法
        //
        commit('DOMAIN', req.hostname || null)
        commit('USER_AGENT', req.headers['user-agent'] || null)

        commit('authModule/TOKEN', req.token || null)
        commit('authModule/TOKEN_EXP', req.tokenExp || null)
        commit('authModule/USER', req.user || null)
        commit('authModule/CSRF_TOKEN', req.csrfToken || null)

        let isMobile
        if (req.query && req.query.isMobile) {
          isMobile = !!req.query.isMobile
        } else {
          isMobile = checkIfMobile(req.headers['user-agent'])
        }
        commit('IS_MOBILE', isMobile)

        // todo: 以下在 Native APP 出來後需要刪除
        // todo: deprecated start
        let isAPP = false
        if (req.query && req.query.uyfrc5ee64ab) {
          isAPP = !!req.query.uyfrc5ee64ab
        }
        if (!isAPP) {
          const isWVRules = [
            // if it says it's a webview, let's go with that
            'WebView',
            // iOS webview will be the same as safari but missing "Safari"
            '(iPhone|iPod|iPad)(?!.*Safari)',
            // https://developer.chrome.com/docs/multidevice/user-agent/#webview_user_agent
            'Android.*Version/[0-9].[0-9]',
            // Also, we should save the wv detected for Lollipop
            // Android Lollipop and Above: webview will be the same as native but it will contain "wv"
            'Android.*wv',
            // old chrome android webview agent
            'Linux; U; Android'
          ]
          const isWVRegex = new RegExp(`(${isWVRules.join('|')})`, 'ig')
          isAPP = Boolean(req.headers['user-agent'].match(isWVRegex))
        }
        commit('IS_APP', isAPP)
        // todo: deprecated end

        commit(
          'IS_IPHONE',
          req.headers['user-agent'].toLowerCase().indexOf('iphone') !== -1
        )

        let isDesktop = false
        if (req.query && req.query.aosigj43rwfk) {
          isDesktop = !!req.query.aosigj43rwfk
        }
        commit('IS_DESKTOP', isDesktop)

        commit('HTTP_STATUS_CODES', {
          ...require('http').STATUS_CODES,
          599: 'Service Unavailable'
        }) // for error page used

        commit('PLATFORM', require('platform').parse(req.headers['user-agent']))

        //
        // 需初始化共用資料的放置在此
        //

        const config = {
          headers: {
            'X-Forwarded-For': require('request-ip').getClientIp(req)
          }
        }

        let locale = null
        if (process.server) {
          locale = req.cookies.locale
        } else {
          locale = state.locale
        }
        locale = locale || process.env.DEFAULT_LOCALE

        const timeout = REQUEST_TIMEOUT
        try {
          //
          // 確認是否是維護狀態
          //
          if (process.env.MAINTAIN_CHECK_URL) {
            const data = await this.$axios.$post(
              `${process.env.MAINTAIN_CHECK_URL}`,
              {},
              getAxiosConfig(context, {
                ...config,
                timeout
              })
            )

            if (data.data !== null) {
              const startTime = $dayjs
                .utc(data.data.startTime)
                .tz()
                .format('HH:mm')

              const endTime = $dayjs
                .utc(data.data.endTime)
                .tz()
                .format('HH:mm')

              return error({
                statusCode: 599,
                maintainStartTime: startTime,
                maintainEndTime: endTime,
                message: data.remark
              })
            }
          }

          //
          // 偵測是否 webapi 有異常
          //
          await this.$axios.$post(
            `/webapi/index/getServerTime`,
            {},
            {
              ...config,
              timeout
            }
          )
        } catch (err) {
          const axiosErr = getAxiosErr(err)

          // ip 限制
          //
          // webapi response message: '非法IP:103.18.56.130'
          // (只要在 getServerTime 的第一次請求處理即可)
          if (axiosErr.statusCode === 403) {
            return error({
              statusCode: 403,
              message: ''
            })
          }

          // webapi 維護中會產生的錯誤訊息
          if (axiosErr?.message.startsWith('connect ECONNREFUSED')) {
            return error({
              statusCode: 503,
              message: ''
            })
          }
          // getServerTime 連線逾時
          if (axiosErr?.message === `timeout of ${timeout}ms exceeded`) {
            return res.status(504).end()
          }
          return serverErrorHandler(err, {
            ...arguments[1],
            store: context
          })
        }

        if (req.error) {
          return error({
            statusCode: req.error.status,
            message: req.error.message,
            path: req.error.path
          })
        }

        // 初始資料

        try {
          //
          // compId
          //

          // common

          // specific
          switch (process.env.COMP_ID) {
            case 'mc':
              await dispatch('getSubMenu', { category: 'qa', locale, config })
              await dispatch('getSubMenu', {
                category: 'terms',
                locale,
                config
              })
              await dispatch('getSubMenu', {
                category: 'beginner',
                locale,
                config
              })
              await dispatch('getSubMenu', {
                category: 'payment',
                locale,
                config
              })
              break
            default:
              break
          }
        } catch (err) {
          serverErrorHandler(err, {
            ...arguments[1],
            store: context
          })
        }
      },
      getServerTime() {
        return this.$axios.$post(`/webapi/index/getServerTime`, {})
      },
      switchLocale({ commit, rootState }, payload) {
        commit('LOCALE', payload)
        // middleware 有在使用
        if (process.client) {
          return this.$axios.$post(
            '/api/switchLocale',
            {
              locale: payload
            },
            {
              headers: {
                'x-csrf-token': rootState.authModule.csrfToken
              }
            }
          )
        }
      },
      getVersion(context) {
        const { commit, rootState, state } = context
        return this.$axios
          .$get('/api/version', {
            headers: {
              'x-csrf-token': rootState.authModule.csrfToken
            }
          })
          .then(data => {
            if (
              !checkAxiosData(data, {
                handleMessages: handleMessages({
                  store: context
                })
              })
            )
              return data
            commit('VERSION', data.result)
            return state.version
          })
          .catch(_ => commit('VERSION', '0.0.0'))
      },
      isForceRefresh(context) {
        const { state } = context
        return this.$axios
          .$post(
            `/webapi/user/forceRefreshCheck`,
            {
              fingerprint: state.deviceId
            },
            getAxiosConfig(context)
          )
          .then(data => {
            if (
              !checkAxiosData(data, {
                handleMessages: handleMessages({
                  store: context
                })
              })
            )
              return data
            return data.data.forceRefresh
          })
      },
      fetch(context, { url, method, data, enctype }) {
        const args = [
          {
            headers: {
              'content-type': enctype || 'multipart/form-data'
            }
          }
        ]
        if (['$post', '$put'].includes(method)) {
          args.unshift(data)
        }
        return this.$axios[method.toLowerCase()](url, ...args)
      },
      getJWTForUser(context, payload) {
        const { rootState } = context
        return this.$axios.$post(`/api/getJWTForUser`, payload, {
          headers: {
            'x-csrf-token': rootState.authModule.csrfToken
          }
        })
      },
      getImageKitFileList(context, payload) {
        let count = 0
        const _getImageKitFileList$ = () => {
          return timer(count * 1000).pipe(
            concatMap(() =>
              from(
                this.$axios.$post(`/api/getImageKitFileList`, {
                  path: payload
                })
              )
            ),
            filter(data =>
              checkAxiosData(data, {
                handleMessages: handleMessages({
                  store: context
                })
              })
            ),
            catchError(err => {
              count++
              return count < 3 ? _getImageKitFileList$() : throwError(err)
            })
          )
        }

        return _getImageKitFileList$().toPromise()
      }
    },
    mutations: {
      IS_MOBILE(state, payload) {
        state.isMobile = payload
      },
      // todo: 以下在 Native APP 出來後需要刪除
      // todo: deprecated start
      IS_APP(state, payload) {
        state.isAPP = payload
      },
      // todo: deprecated end
      IS_DESKTOP(state, payload) {
        state.isDesktop = payload
      },
      IS_IPHONE(state, payload) {
        state.isIPhone = payload
      },
      HTTP_STATUS_CODES(state, payload) {
        state.httpStatusCodes = payload
      },
      LOCALE(state, locale) {
        state.locale = locale
      },
      LOCALES(state, locales) {
        state.locales = locales
      },
      DOMAIN(state, payload) {
        state.domain = payload
      },
      USER_AGENT(state, payload) {
        state.userAgent = payload
      },
      DEVICE_ID(state, payload) {
        state.deviceId = payload
      },
      IS_PAGE_LOADED(state, payload) {
        state.isPageLoaded = payload
      },
      GLOBAL_MESSAGE(state, payload) {
        state.globalMessage = payload
      },
      VERSION(state, payload) {
        state.version = payload
      },
      PLATFORM(state, payload) {
        state.platform = payload
      }
    },
    getters: {
      isMobile: state => state.isMobile,
      // todo: 以下在 Native APP 出來後需要刪除
      // todo: deprecated start
      isAPP: state => state.isAPP,
      // todo: deprecated end
      isDesktop: state => state.isDesktop,
      isIPhone: state => state.isIPhone,
      httpStatusCodes: state => state.httpStatusCodes,
      locales: state => state.locales,
      locale: state => state.locale,
      domain: state => state.domain,
      userAgent: state => state.userAgent,
      deviceId: state => state.deviceId,
      isPageLoaded: state => state.isPageLoaded,
      globalMessage: state => state.globalMessage,
      version: state => state.version,
      platform: state => state.platform
    },
    modules: {
      loadingModule,
      headerModule,
      authModule,
      marqueeModule,
      bannerModule,
      jackpotModule,
      promotionModule,
      userModule,
      userIndexModule,
      userFinancialServiceModule,
      userAccountSettingModule,
      userPromotionReceiveModule,
      userRecordQueryModule,
      userStationLetterModule,
      userInboxModule,
      annoModule,
      gameModule,
      sportModule,
      lotteryTicketModule,
      chessModule,
      cockfightingModule,
      cmsModule,
      kycModule,
      subscribeModule,
      websocketModule,
      vipModule,
      popupModule
    }
  })

export default store
